/**
 * DPL DEW — Tenant Application Shell
 * Renders the main tenant app (Index) and injects Business Identity variables
 */

import { useEffect } from 'react';
import Index from '@/pages/Index';
import { useIdentityStore } from '@/stores/identityStore';
import { GlobalRavanFAB } from '@/components/ravan/GlobalRavanFAB';
import { GlobalRavanOverlay } from '@/components/ravan/GlobalRavanOverlay';

const TenantLayout = () => {
  const { identity, fetchIdentity } = useIdentityStore();

  useEffect(() => {
    fetchIdentity();
  }, [fetchIdentity]);

  useEffect(() => {
    const root = document.documentElement;

    // Apply Brand Color (Primary) if valid hex
    if (identity.brand_color && /^#([0-9A-F]{3}){1,2}$/i.test(identity.brand_color)) {
      // Very basic validation, we should parse hex to HSL if we rely on HSL tokens in index.css.
      // But we can set a raw CSS var for the branding.
      root.style.setProperty('--brand-primary', identity.brand_color);
    } else {
      root.style.removeProperty('--brand-primary');
    }

    // Apply Accent Color if valid hex
    if (identity.accent_color && /^#([0-9A-F]{3}){1,2}$/i.test(identity.accent_color)) {
      root.style.setProperty('--brand-accent', identity.accent_color);
    } else {
      root.style.removeProperty('--brand-accent');
    }

    // Apply Typography
    if (identity.typography_preset) {
      root.setAttribute('data-typography', identity.typography_preset);
    }

    // Apply Theme Mode (light/dark)
    if (identity.theme_mode === 'dark') {
      root.classList.add('dark');
    } else if (identity.theme_mode === 'light') {
      root.classList.remove('dark');
    } else {
      // System mode
      if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
        root.classList.add('dark');
      } else {
        root.classList.remove('dark');
      }
    }

  }, [identity]);

  return (
    <>
      <Index />
      <GlobalRavanFAB />
      <GlobalRavanOverlay />
    </>
  );
};

export default TenantLayout;
